<template>
    <div class="complectation-element-manage flex flex-col">
        <div class="title flex justify-between items-center">
            <span>{{ $t("client.barriers.title") }}</span>
            <button
                @click="$store.dispatch('clientMain/setManageElement', null)"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="body flex-1 overflow-x-hidden">
            <div class="manage-step">
                <div class="manage-step-title">
                    {{ $t("client.barriers.select_type_barrier") }}:
                </div>
                <!-- select element and load that detail -->
                <div class="manage-step-body">
                    <div class="element-list-types" v-if="types.length">
                        <div
                            class="choose-element-type"
                            v-for="(type, ndx) in types"
                            :key="`element-type-${ndx}`"
                        >
                            <div class="choose-element-type-title">
                                <button
                                    class="flex justify-between items-center focus:outline-none w-full"
                                    @click="showElementsByType(type)"
                                >
                                    <span class="img-txt flex items-center">
                                        <span
                                            class="img flex justify-between items-center"
                                            ><img :src="type.image" alt=""
                                        /></span>
                                        <span class="txt ml-2">{{
                                            type.name
                                        }}</span>
                                    </span>
                                    <span
                                        class="arrow-down"
                                        :class="{
                                            rotate: types[ndx].showElements,
                                        }"
                                        style="
                                            background-image: url('/images/icons/icon-right-arrow.svg');
                                        "
                                    >
                                    </span>
                                </button>
                            </div>
                            <OgradiSidebarElements
                                :id="`barriers__root-${type.type_id}`"
                                v-if="
                                    (types[ndx].showElements &&
                                        type.elements.length > 0) ||
                                    (selectedElement &&
                                        selectedElement.type_id ==
                                            type.type_id &&
                                        types[ndx].showElements)
                                "
                                :type="type"
                                :selected="selectedElement"
                                @mountedElements="
                                    setLoadingObserver(type.type_id)
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="manage-step"
                v-if="
                    selectedElement &&
                    !selectedElement.bez_kalitki &&
                    !selectedElement.bez_prohoda
                "
            >
                <div class="manage-step-title">
                    {{ $t("client.barriers.select_door_position") }}:
                </div>
                <div class="manage-step-body">
                    <div class="door__position-wrapper">
                        <div>
                            <div class="door__position">
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'a',
                                            }
                                        )
                                    "
                                    class="door__position_a"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'a',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>A</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'b',
                                            }
                                        )
                                    "
                                    class="door__position_b"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'b',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>B</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'c',
                                            }
                                        )
                                    "
                                    class="door__position_c"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'c',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>C</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'd',
                                            }
                                        )
                                    "
                                    class="door__position_d"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'd',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>D</span>
                                </button>
                                <div class="barrier__zahoronenie"></div>
                            </div>
                        </div>

                        <div class="door__open">
                            <div class="mb-4">
                                <div class="door__open_title">
                                    {{ $t("client.barriers.where_place") }}
                                </div>
                                <div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeLeft"
                                            id="kalitka-place-left"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeLeft'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeLeft',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-left"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.place_left") }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeRight"
                                            id="kalitka-place-right"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeRight'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeRight',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-right"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.place_right") }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeCenter"
                                            id="kalitka-place-center"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeCenter'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeCenter',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-center"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{
                                                $t("main.place_center")
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="door__open_title">
                                    {{ $t("client.barriers.how_open") }}
                                </div>
                                <div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="rightleft"
                                            value="left"
                                            id="kalitka-left"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .how == 'left'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'how',
                                                        value: 'left',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-left"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.to_left") }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="rightleft"
                                            value="right"
                                            id="kalitka-right"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .how == 'right'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'how',
                                                        value: 'right',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-right"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.to_right") }}</label
                                        >
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="door__open_title">
                                    {{ $t("client.barriers.where_open") }}
                                </div>
                                <div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="inout"
                                            value="out"
                                            id="kalitka-out"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .where == 'out'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'where',
                                                        value: 'out',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-out"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{
                                                $t("client.barriers.to_out")
                                            }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="inout"
                                            value="in"
                                            id="kalitka-in"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .where == 'in'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'where',
                                                        value: 'in',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-in"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{
                                                $t("client.barriers.to_in")
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="manage-step"
                v-if="
                    selectedElement &&
                    selectedElement.bez_kalitki &&
                    !selectedElement.bez_prohoda
                "
            >
                <div class="manage-step-title">
                    {{ $t("client.barriers.select_position_going") }}:
                </div>
                <div class="manage-step-body">
                    <div class="door__position-wrapper">
                        <div>
                            <div class="door__position">
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'a',
                                            }
                                        )
                                    "
                                    class="door__position_a prohod__position"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'a',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>A</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'b',
                                            }
                                        )
                                    "
                                    class="door__position_b prohod__position"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'b',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>B</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'c',
                                            }
                                        )
                                    "
                                    class="door__position_c prohod__position"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'c',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>C</span>
                                </button>
                                <button
                                    @click="
                                        $store.dispatch(
                                            'clientBarriers/selectDoorPosition',
                                            {
                                                item: 'side',
                                                value: 'd',
                                            }
                                        )
                                    "
                                    class="door__position_d prohod__position"
                                    :class="{
                                        active:
                                            selectedElement.doorPosition.side ==
                                            'd',
                                        howLeft:
                                            selectedElement.doorPosition.how ==
                                            'left',
                                        howRight:
                                            selectedElement.doorPosition.how ==
                                            'right',
                                        whereIn:
                                            selectedElement.doorPosition
                                                .where == 'in',
                                        whereOut:
                                            selectedElement.doorPosition
                                                .where == 'out',
                                    }"
                                >
                                    <span>D</span>
                                </button>
                                <div class="barrier__zahoronenie"></div>
                            </div>
                        </div>
                        <div class="door__open">
                            <div class="mb-4">
                                <div class="door__open_title">
                                    {{ $t("client.barriers.where_place") }}
                                </div>
                                <div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeLeft"
                                            id="kalitka-place-left"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeLeft'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeLeft',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-left"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.place_left") }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeRight"
                                            id="kalitka-place-right"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeRight'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeRight',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-right"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{ $t("main.place_right") }}</label
                                        >
                                    </div>
                                    <div class="mb-2">
                                        <input
                                            type="radio"
                                            name="wherePlace"
                                            value="placeCenter"
                                            id="kalitka-place-center"
                                            class="landscaping__types-radio"
                                            :checked="
                                                selectedElement.doorPosition
                                                    .wherePlace == 'placeCenter'
                                            "
                                            @change="
                                                $store.dispatch(
                                                    'clientBarriers/selectDoorPosition',
                                                    {
                                                        item: 'wherePlace',
                                                        value: 'placeCenter',
                                                    }
                                                )
                                            "
                                        />
                                        <label
                                            class="landscaping__types-label"
                                            for="kalitka-place-center"
                                            ><span
                                                class="landscaping__types-icon"
                                                ><span></span></span
                                            >{{
                                                $t("main.place_center")
                                            }}</label
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.arrow-down {
    width: 10px;
    height: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    transition: transform 0.3s ease;
    display: inline-block;
}
.arrow-down.rotate {
    transform: rotate(90deg);
}
.door__open {
    padding-top: 35px;
}
.door__open_title {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 0.5rem;
}
.door__position-wrapper {
    display: flex;
}
.door__position {
    position: relative;
    margin-left: -10px;
    margin-right: 10px;
}
.door__position button {
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
}
.door__position button:focus {
    outline: none;
}
.door__position button span {
    background-color: #f5f6c1;
    display: inline-block;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
}
.door__position_a,
.door__position_c {
    height: 50px;
    width: 180px;
}
.door__position_b,
.door__position_d {
    height: 180px;
    width: 50px;
}

.door__position_a {
    top: 0;
    left: 50px;
}

.door__position_b {
    right: 0;
    top: 50px;
}

.door__position_c {
    bottom: 0;
    left: 50px;
}
.door__position_d {
    top: 50px;
    left: 0;
}

.door__position_a {
    background-image: url("/images/storony-ogrady/storona-a.svg");
    background-position: bottom center;
}
.door__position_a.active.howLeft.whereOut {
    background-image: url("/images/storony-ogrady/storona-a-na-l.svg");
}

.door__position_a.active.howRight.whereOut {
    background-image: url("/images/storony-ogrady/storona-a-na-r.svg");
}
.door__position_a.active.howLeft.whereIn {
    background-image: url("/images/storony-ogrady/storona-a-vn-l.svg");
    top: 28px;
}
.door__position_a.active.howRight.whereIn {
    background-image: url("/images/storony-ogrady/storona-a-vn-r.svg");
    top: 28px;
}

.door__position_b {
    background-image: url("/images/storony-ogrady/storona-b.svg");
    background-position: center left;
}
.door__position_b.active.howLeft.whereOut {
    background-image: url("/images/storony-ogrady/storona-b-na-l.svg");
}
.door__position_b.active.howRight.whereOut {
    background-image: url("/images/storony-ogrady/storona-b-na-r.svg");
}
.door__position_b.active.howLeft.whereIn {
    background-image: url("/images/storony-ogrady/storona-b-vn-l.svg");
    right: 28px;
}
.door__position_b.active.howRight.whereIn {
    background-image: url("/images/storony-ogrady/storona-b-vn-r.svg");
    right: 28px;
}

.door__position_c {
    background-image: url("/images/storony-ogrady/storona-c.svg");
    background-position: top center;
}
.door__position_c.active.howLeft.whereOut {
    background-image: url("/images/storony-ogrady/storona-c-na-l.svg");
}
.door__position_c.active.howRight.whereOut {
    background-image: url("/images/storony-ogrady/storona-c-na-r.svg");
}
.door__position_c.active.howLeft.whereIn {
    background-image: url("/images/storony-ogrady/storona-c-vn-l.svg");
    bottom: 28px;
}
.door__position_c.active.howRight.whereIn {
    background-image: url("/images/storony-ogrady/storona-c-vn-r.svg");
    bottom: 28px;
}

.door__position_d {
    background-image: url("/images/storony-ogrady/storona-d.svg");
    background-position: center right;
}
.door__position_d.active.howLeft.whereOut {
    background-image: url("/images/storony-ogrady/storona-d-na-l.svg");
}
.door__position_d.active.howRight.whereOut {
    background-image: url("/images/storony-ogrady/storona-d-na-r.svg");
}
.door__position_d.active.howLeft.whereIn {
    background-image: url("/images/storony-ogrady/storona-d-vn-l.svg");
    left: 28px;
}
.door__position_d.active.howRight.whereIn {
    background-image: url("/images/storony-ogrady/storona-d-vn-r.svg");
    left: 28px;
}

.door__position_a.active.prohod__position {
    background-image: url("/images/prohod/storona-a-bez-k.svg");
}
.door__position_b.active.prohod__position {
    background-image: url("/images/prohod/storona-b-bez-k.svg");
}
.door__position_c.active.prohod__position {
    background-image: url("/images/prohod/storona-c-bez-k.svg");
}
.door__position_d.active.prohod__position {
    background-image: url("/images/prohod/storona-d-bez-k.svg");
}

.barrier__zahoronenie {
    background-image: url("/images/storony-ogrady/zahoronenie.svg");
    background-position: center center;
    background-repeat: no-repeat;
    width: 280px;
    height: 280px;
}
.landscaping__types-label {
    font-size: 16px;
}
.complectation-element-manage .manage-step + .manage-step {
    padding-top: 1.5rem;
}
@media screen and (max-width: 1000px) {
    .door__position-wrapper {
        flex-direction: column;
    }
    .door__position {
        margin-right: 0;
    }
}
</style>
<script>
import OgradiSidebarElements from "./OgradiSidebar/OgradiSidebarElements.vue";
export default {
    components: { OgradiSidebarElements },
    name: "Ogradi",
    created() {
        this.$store.dispatch("clientBarriers/fetch");
        if (this.selectedElement) {
            this.$store.commit(
                "clientBarriers/SELECT_ELEMENT",
                this.selectedElement
            );
        }
    },
    methods: {
        async showElementsByType(type) {
            if (type.showElements) {
                this.$store.dispatch(
                    "clientBarriers/clearTypeElements",
                    type.type_id
                );
            } else {
                await this.$store.dispatch(
                    "clientBarriers/getElementsByType",
                    type.type_id
                );
            }

            this.$store.dispatch("clientBarriers/setTypeShowElements", {
                typeId: type.type_id,
                show: !type.showElements,
            });
        },

        setLoadingObserver(typeId) {
            const element = document.getElementById(
                `barriers__loader-${typeId}`
            );
            const rootElement = document.getElementById(
                `barriers__root-${typeId}`
            );

            if (rootElement && element) {
                const loadingObserver = new IntersectionObserver(
                    async (entries) => {
                        entries.forEach(async (entry) => {
                            if (entry.isIntersecting) {
                                await this.$store.dispatch(
                                    "clientBarriers/getElementsByType",
                                    typeId
                                );
                            }
                        });
                    },
                    {
                        root: rootElement,
                        threshold: 0.5,
                    }
                );
                loadingObserver.observe(element);
            }
        },
    },
    computed: {
        types() {
            return this.$store.state.clientBarriers.types;
        },
        elements() {
            return this.$store.state.clientBarriers.elements;
        },
        selectedType() {
            return this.$store.state.clientBarriers.selectedType;
        },
        selectedElement() {
            return this.$store.state.clientOrder.barrier;
        },
    },
};
</script>
